export default "/protocols.5e4c1cf3ef58a848b045b2f985524c14.png";